var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPulse = function SvgPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.002h2.5a1 1 0 0 0 .894-.552l.793-1.575 1.343 5.368a1 1 0 0 0 1.935.021l2.059-7.535 1.014 3.548a1 1 0 0 0 .962.725H15a1 1 0 0 0 0-2h-1.744l-1.794-6.276a1 1 0 0 0-1.927.012L7.544 10.05 6.47 5.757a1 1 0 0 0-1.864-.2L2.88 9.002H1a1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })));
};
export default SvgPulse;